import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

const initPopup = ({lenis}: {lenis: Lenis}) => {
  gsap.registerPlugin(ScrollToPlugin);

    const triigers = document.querySelectorAll<HTMLElement>('.js_popup_trigger');
    const popups = document.querySelectorAll<HTMLElement>('.c_popup');
  
    if(popups.length === 0) return;

    const openPopup = (popup: HTMLElement) => {
      popup.hidden = false;
      popup.classList.add('is_open');
      lenis.stop();
    };

    const closePopup = (popup: HTMLElement) => {
      popup.classList.remove('is_open');
      popup.hidden = true;
      lenis.start();
    };
  
    triigers.forEach(trigger => {    
      trigger.addEventListener('click', () => {
        const triggerData = trigger.getAttribute('data-popup');
        if(!triggerData) return;
        const popup = document.querySelector<HTMLElement>(`.js_popup#${triggerData}`);
        if(!popup) return;
        openPopup(popup);

        // .c_popup_wrapper
        const wrapper = popup.querySelector<HTMLElement>('.c_popup_wrapper');                
        if(!wrapper) return;
        gsap.to(wrapper, {
          scrollTo: 0,
          duration: .1,
          ease: 'power4.out',
        });
      });
    });
  
    const $closeButtons = document.querySelectorAll('.js_popup_close');
    $closeButtons.forEach(closeButton => {
      closeButton.addEventListener('click', () => {
        const closeButtonData = closeButton.getAttribute('data-target');
        if(!closeButtonData) return;
        const popup = document.querySelector<HTMLElement>(`.js_popup#${closeButtonData}`);
        if(!popup) return;
        closePopup(popup);
      });
    });
  };

export default initPopup;